import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import {
  GET_FILTERD_SALE,
  GET_MINE_SALE_ORDER_DETAILS,
  GET_SALE,
  GET_SALE_BY_ID,
  GET_SALE_MINE,
  GET_SALE_ORDER_DETAILS,
  GET_SALE_REQUEST_BY_ID,
} from "../constants";
import { bxpAcceptReject, getBxpTogether1 } from "../ots/action";
import { getPostCounts } from "../posts/action";

export const getSaleList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`sale`);
    if (response?.data?.status) {
      dispatch({ type: GET_SALE, getsalelist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const FilterSaleListings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("sale", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_SALE, getfilterdsale: response.data });
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const insertRequestinProduct = (data, id) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("sale/request/create", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      if (id) {
        dispatch(getSellById(id));
      }
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMineSaleList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`sale?is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_SALE_MINE,
        getminesalelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addSell = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("sale/create", data);
    if (response?.data?.status) {
      dispatch(getMineSaleList());
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateSell = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("sale/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineSaleList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getSellById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`sale/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({ type: GET_SALE_BY_ID, getsalebyid: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const addtowishSellbyid = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`sale/id?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      dispatch(getSellById(id));
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const deleteSell = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`sale/delete?id=${id}`);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostCounts(6));
      dispatch(getMineSaleList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getMineSaleOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `sale?is_mine=1&status=${status}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_SALE_ORDER_DETAILS,
        minesaleorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const getSaleOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`sale?status=${status}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_SALE_ORDER_DETAILS,
        saleorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const saleAcceptReject = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("sale/request/update", data);
    if (response?.data?.status) {
      dispatch(getBxpTogether1(1));
      dispatch(getPostCounts(7));
      urtoast(response?.data?.response?.message, 1);
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getSaleRequestById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `sale/request/id?sale_request_id=${id}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_SALE_REQUEST_BY_ID,
        getsalerequestbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const paySaleAmount = (data, navigate) => async (dispatch) => {
  try {
    const payload = { ...data, wallet: data?.wallet || 0 };
    const response = await axiosInstance.post("payment", payload);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      navigate(-2);
      dispatch(getSaleRequestById(data?.id));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateSaleStatus = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("sale/request/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      dispatch(getSaleRequestById(data?.id));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const saleRequest = (data, setLoading, navigate) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("sale/request/update", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);

      if (response?.data?.response) {
        setLoading(false);
        navigate(data?.url, {
          state: {
            orderdetails: {
              ...data?.state,
            },
          },
        });
        urtoast(response?.data?.response?.message, 1);
      }
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const relistSaleProductAPI = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("sale/create", data);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      dispatch(getMineSaleOrderList(4));
    } else {
      urtoast(response?.data?.response?.message, 2);
    }
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};
